<footer class="footer">
  <div class="footer__left">
    <button type="button" class="footer__left__logo">
      <img src="/assets/img/logo/powerpay-purple-isotype-logo.svg" alt="Logo de Powerpay" />
    </button>
    <div class="footer__left__copyright">
      © 2022 {{ CONST.BBVA_PRODUCT_NAME }}, Derechos Reservados.
    </div>
  </div>
  <div class="footer__right">
    <button type="button" class="link" (click)="onGoToPrivacyPolicy()">
      Política de Privacidad
    </button>
    <button type="button" class="link" (click)="onGoToTermsAndConditions()">
      Términos y Condiciones
    </button>
    <!-- TODO: Uncomment when the landing is ready -->
    <!-- <button type="button" class="link" (click)="onGoToFaqs()">Preguntas frecuentes</button> -->
  </div>
</footer>
